import styled from 'styled-components';
import { ExceptionsActionType } from 'store/vat/models';

export const TransactionTableWrapper = styled.div`
  .transaction-table {
    table {
      border-collapse: separate;
      border-spacing: 0 5px;
    }

    .ant-table-thead {
      font-size: 12px;
      font-weight: 600;
      line-height: 24px;
      text-align: left;
    }

    .ant-table-thead .ant-table-column-title {
      font-weight: 600 !important;
    }

    .ant-table-thead > tr > th,
    .ant-table-thead > tr > td {
      border-bottom: none;
    }

    .ant-table-thead > tr > th::before {
      width: 0px !important;
      background-color: var(--color-border, #dbeae3) !important;
    }

    .ant-table-tbody > tr > td {
      height: 40px;
      padding: 4px 12px;
      border-bottom: none;
      vertical-align: middle;
    }

    .ant-table-tbody > tr > td {
      background-color: var(--color-surface, #f3f7f8);
    }

    .ant-table-tbody > tr > td:first-child {
      border-end-start-radius: 10px;
      border-start-start-radius: 10px;
    }

    .ant-table-tbody > tr > td:last-child {
      border-start-end-radius: 10px;
      border-end-end-radius: 10px;
    }

    .ant-table-row,
    td.ant-table-column-sort {
      background-color: var(--color-surface, #f3f7f8);
      margin-bottom: 5px;
    }

    .ant-table-row:hover * a,
    .ant-table-row:hover * span[title] {
      text-decoration: underline;
    }

    .ant-table-row > .ant-table-cell-row-hover {
      background-color: #e6eff2 !important;
      .testing-icon {
        display: block;
      }
    }

    .testing-icon {
      display: none;
    }

    th.ant-table-column-sort,
    th.ant-table-column-has-sorters:hover {
      background-color: var(--color-surface-base, #ffffff) !important;
    }

    .ant-table-column-title {
      padding-right: 5px;
      z-index: 0 !important;
    }

    .ant-table-column-sorters {
      width: fit-content !important;
    }

    .ant-table-column-sorters > .ant-table-column-title,
    .ant-table-cell,
    .ant-space-item {
      width: max-content;
    }

    .ant-table-cell {
      text-wrap: nowrap;
      font-size: 12px;
      font-weight: 400;
    }

    .ant-table-content {
      scrollbar-width: thin;
      width: 100%;
    }

    /* Exception type styling */
    :where(
        .ant-table-row:has(
            td:nth-child(1)
              > div[data-exception-type='${ExceptionsActionType.ADJUSTMENT}']
          )
      )
      > td {
      background: #f8f8eb !important;
    }

    :where(
        .ant-table-row:has(
            td:nth-child(1)
              > div[data-exception-type='${ExceptionsActionType.CURRENT_RETURN}']
          )
      )
      > td {
      background: #ebf8f8 !important;
    }

    /* Highlighted transaction row */
    .highlighted-transaction-row > td {
      background: var(--color-status-warning-bg, #fff5e2) !important;
    }

    /* Slightly darker hover for highlighted row */
    .highlighted-transaction-row:hover > td {
      background: #ffefcc !important;
    }

    /* Pagination styling */
    .ant-pagination-total-text {
      margin-top: 10px;
      flex: 1;
    }

    .ant-pagination-item {
      border-radius: 10px;
    }

    .ant-pagination-prev,
    .ant-pagination-next {
      border-radius: 10px;
    }

    /* Sorter tooltip */
    .ant-table-show-sorter-tooltip {
      .ant-tooltip-inner {
        font-size: 13px;
        font-weight: 400;
        background-color: white;
        color: var(--color-text-muted, #5a6a6a);
      }
    }

    /* Table title */
    .ant-table-title {
      padding: 0px 0px !important;
    }

    .exception-row > td {
      background: #e6f4ea !important;
    }

    .exception-bar {
      background: var(--color-primary, #41aaaf) !important;
      border-top-left-radius: 10px !important;
      border-bottom-left-radius: 10px !important;
    }

    .exception-row:hover > td {
      background: #d6f1e5 !important;
    }

    /* Row edge caps + fixed-column shadows — match dark table surfaces */
    .ant-table-cell-fix-left,
    .ant-table-cell-fix-right {
      background: inherit !important;
    }

    .ant-table-cell-fix-left-first::after,
    .ant-table-cell-fix-right-first::after,
    .ant-table-cell-fix-right-last::after {
      box-shadow: none !important;
    }
  }

  html[data-theme='dark'] & .transaction-table {
    .ant-table-tbody > tr > td,
    .ant-table-row,
    td.ant-table-column-sort {
      background-color: var(--color-surface, #132122) !important;
      color: var(--color-text-base, #e3eaeb) !important;
    }

    .ant-table-row > .ant-table-cell-row-hover {
      background-color: #203739 !important;
    }

    .ant-empty .ant-empty-description,
    .ant-empty-description {
      color: var(--color-text-muted, #a9b8b9) !important;
    }

    .ant-empty .ant-empty-image svg,
    .ant-empty-image svg {
      color: var(--color-text-muted, #a9b8b9) !important;
      fill: currentColor !important;
    }

    .ant-pagination-total-text,
    .ant-pagination-total-text .ant-typography {
      color: var(--color-text-base, #e3eaeb) !important;
    }
  }
`;
